import { render, staticRenderFns } from "./BudgetGlobal.vue?vue&type=template&id=cd8a947e&scoped=true&"
import script from "./BudgetGlobal.vue?vue&type=script&lang=js&"
export * from "./BudgetGlobal.vue?vue&type=script&lang=js&"
import style0 from "./BudgetGlobal.vue?vue&type=style&index=0&id=cd8a947e&prod&scoped=true&lang=css&"
import style1 from "./BudgetGlobal.vue?vue&type=style&index=1&id=cd8a947e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8a947e",
  null
  
)

export default component.exports